<script>
    import PageHeader from '../components/page-header/page-header.vue';
    import MotivationInfo from '../components/motivation-info/motivation-info.vue';

    export default {
        components: { PageHeader, MotivationInfo }
    };
</script>

<template>
    <body>
        <page-header></page-header>
        <motivation-info></motivation-info>
    </body>

</template>



// WEBPACK FOOTER //
// src/pages/index.vue?b9c64b62